import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getScopeShippingPriceKey, sumScopeQuantities } from 'utils/scopeOrderUtils'

export default (shippingAddress, overrideScopeQuantities = null) => {
  const allScopeShippingFees = useSelector(state => state.productReducer.shippingFees)
  const practiceCountry = useSelector(state => state.practiceReducer.details.country)
  const shippingCountry = useMemo(
    () => shippingAddress?.country || practiceCountry,
    [practiceCountry, shippingAddress?.country]
  )
  const orderScopeQuantities = useSelector(state => state.billingReducer.order.grinKitsQuantity)
  const scopesQuantities = overrideScopeQuantities || orderScopeQuantities

  const totalScopesAmount = useMemo(() => sumScopeQuantities(scopesQuantities), [scopesQuantities])
  const shippingFee = useMemo(() => {
    if (!allScopeShippingFees?.prices) return 0

    const priceKey = getScopeShippingPriceKey({
      shippingCountry,
      totalScopesAmount
    })
    const priceId = allScopeShippingFees.metadata[priceKey]

    return allScopeShippingFees.prices.find(price => price.priceId === priceId)
  }, [allScopeShippingFees, shippingCountry, totalScopesAmount])

  return {
    allScopeShippingFees,
    shippingFee
  }
}
